export default __webpack_public_path__ + "static/media/trash-can.9785adfc.svg";